// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.ennowallet",
    name: "Enno Wallet",
    homepage: "https://www.ennowallet.com",
    image_id: "ae4f5167-0b61-43bd-7d76-1f8579271000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/enno-wallet/id1577011660#iosmph",
        android: "https://play.google.com/store/apps/details?id=com.app.awqsome.ennowallet#gpmph",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "ennowallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map